import React from 'react';
import { getDescription } from '../../../helpers/utils';
import { usePager } from '../../../helpers/pagination';
import SideBar from '../../Common/SideBar';
import PageIndicator from '../../Common/PageIndicator';
import Row from './Row';
import SpotlightHeader from '../../Common/Header';
import './ProductSalesByStore.scss';
const getFormattedData = (data, metadata) => {
  var _metadata$results;
  const {
    timezone,
    group_name,
    own,
    last_row: last_date
  } = data;
  const {
    boh_period,
    boh_date_range,
    boh_event_type,
    boh_show_dollar_amount
  } = metadata;
  const results = (_metadata$results = metadata.results) !== null && _metadata$results !== void 0 ? _metadata$results : 10;
  const isOwnInRanking = (own === null || own === void 0 ? void 0 : own.ranking) <= results;
  const bohLocations = data.top.slice(0, results);
  const description = getDescription(timezone, boh_event_type, boh_period, boh_date_range, `${group_name} sales`, last_date);
  const display_dollar_amount = boh_show_dollar_amount !== false;
  const hide_poweredbyupshow = metadata.hide_poweredbyupshow;
  return {
    own,
    isOwnInRanking,
    bohLocations,
    description,
    display_dollar_amount,
    hide_poweredbyupshow
  };
};
const ProductSalesByStore = props => {
  const {
    data,
    metadata,
    text,
    duration,
    playing,
    bohStyle
  } = props;
  const {
    accent_color,
    title_font_family,
    text_accent_color,
    containerStyle,
    listHeaderRowStyle
  } = bohStyle;
  const {
    bohLocations,
    own,
    isOwnInRanking,
    description,
    display_dollar_amount,
    hide_poweredbyupshow
  } = getFormattedData(data, metadata);
  const [page, pageIdx, pages] = usePager(bohLocations, duration * 1000, playing);
  const Header = /*#__PURE__*/React.createElement(SpotlightHeader, {
    text: text,
    metadata: metadata,
    description: description,
    isLeaderboard: true
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "product-sales-container",
    style: containerStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "width-container"
  }, Header, /*#__PURE__*/React.createElement("div", {
    className: "product-sales-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "list-row list-header",
    style: listHeaderRowStyle
  }, /*#__PURE__*/React.createElement("p", {
    className: "location_header"
  }, "Location"), /*#__PURE__*/React.createElement("p", null, "Quantity Sold"), display_dollar_amount && /*#__PURE__*/React.createElement("p", null, "Dollar Amount")), page.map((e, index) => /*#__PURE__*/React.createElement(Row, {
    key: `${e.name}-${index}`,
    location: e,
    accent_color: accent_color,
    own: own,
    text: text,
    display_dollar_amount: display_dollar_amount
  })), !!own && !isOwnInRanking && /*#__PURE__*/React.createElement(Row, {
    key: `${own.name}`,
    location: own,
    accent_color: accent_color,
    own: own,
    text: text,
    display_dollar_amount: display_dollar_amount
  })), pages.length > 1 && /*#__PURE__*/React.createElement(PageIndicator, {
    pages: pages,
    current: pageIdx,
    selectedColor: accent_color
  }))), /*#__PURE__*/React.createElement(SideBar, {
    accent_color: accent_color,
    accent_text_color: text_accent_color,
    logo: metadata.logo,
    text: text.message_board,
    fontFamily: title_font_family,
    hide_poweredbyupshow: hide_poweredbyupshow
  }));
};
export default ProductSalesByStore;